import React from 'react';
import { Container } from 'react-bootstrap';
import { Redirect, Route, Switch } from 'react-router-dom';

import Suspense from '../../../../shared/components/suspense';
import ErrorBoundaryWrapper from '../../../../shared/components/error-boundary-wrapper';

import DoNotCallList from './components/do-not-call-list/do-not-call-list-container';
import DoNotCallListDetails from './components/do-not-call-list-details/do-not-call-list-details-container';

const DoNotCall: React.FC = () => (
  <Container fluid className="p-0 d-flex flex-column overflow-hidden h-100">
    <ErrorBoundaryWrapper>
      <Suspense>
        <Switch>
          <Route
            exact
            path="/settings/call-dnc-list"
            component={DoNotCallList}
          />
          <Route
            exact
            path="/settings/call-dnc-list/:listId"
            component={DoNotCallListDetails}
          />
          <Redirect to="/settings/call-dnc-list" />
        </Switch>
      </Suspense>
    </ErrorBoundaryWrapper>
  </Container>
);

export default DoNotCall;
